export default "__VITE_ASSET__HWysMNOv__"